import ApiConfig from '../../config/api'

import BaseListModel from './BaseListModel'

export default class InstanceModel extends BaseListModel {
  apiUrl = ApiConfig.api.machine.instance_list
}

export const instanceStore = new InstanceModel()
